const STORAGE_KEY = 'fpVisitorId';
const EVENT_STORAGE_KEY = 'fpEventId';

const readFromResult = (result) =>
  result?.visitor_id || result?.visitorId || null;

const readEventFromResult = (result) =>
  result?.event_id || result?.eventId || result?.requestId || null;

const readFromStorage = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || null;
  } catch (e) {
    return null;
  }
};

const readEventFromStorage = () => {
  try {
    return sessionStorage.getItem(EVENT_STORAGE_KEY) || null;
  } catch (e) {
    return null;
  }
};

const saveToStorage = (visitorId) => {
  if (!visitorId) return;

  try {
    sessionStorage.setItem(STORAGE_KEY, visitorId);
  } catch (e) {}
};

const saveEventToStorage = (eventId) => {
  if (!eventId) return;

  try {
    sessionStorage.setItem(EVENT_STORAGE_KEY, eventId);
  } catch (e) {}
};

export const getVisitorId = async (timeoutMs = 4000) => {
  if (typeof window === 'undefined') return null;

  if (!window.fpVisitorIdPromise) return null;

  const known = readFromResult(window.fpResult) || readFromStorage();
  if (known) {
    saveToStorage(known);
    return known;
  }

  try {
    const timeout = new Promise((resolve) =>
      setTimeout(() => resolve(null), timeoutMs)
    );
    const visitorId = await Promise.race([window.fpVisitorIdPromise, timeout]);

    saveToStorage(visitorId);

    return visitorId || null;
  } catch (e) {
    return null;
  }
};

export const getEventId = async (timeoutMs = 4000) => {
  if (typeof window === 'undefined') return null;

  if (!window.fpVisitorIdPromise) return null;

  const known = readEventFromResult(window.fpResult) || readEventFromStorage();
  if (known) {
    saveEventToStorage(known);
    return known;
  }

  try {
    const timeout = new Promise((resolve) =>
      setTimeout(() => resolve(null), timeoutMs)
    );
    await Promise.race([window.fpVisitorIdPromise, timeout]);

    const eventId =
      readEventFromResult(window.fpResult) || readEventFromStorage();

    saveEventToStorage(eventId);

    return eventId || null;
  } catch (e) {
    return null;
  }
};

export const VISITOR_LIMIT_STATUS = 'VISITOR_LIMIT_EXCEEDED';

const LIMIT_PATTERN = /LIMIT|EXCEED|TOO[_ -]?MANY|VISITOR/i;

const matchesLimit = (value) =>
  typeof value === 'string' && LIMIT_PATTERN.test(value);

export const isVisitorLimitError = (error) => {
  const response = error?.response;
  if (!response) return false;

  const { status, data } = response;
  if (status === 429) return true;
  if (status < 400 || status >= 500 || !data) return false;

  return [
    data.code,
    data.errorCode,
    data.error,
    data.status,
    data.message
  ].some(matchesLimit);
};
